export default "__VITE_ASSET__B7kBc$vk__"